/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-12-21 10:21:40
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Stack, RadioButton } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { FEEDBACK_ALL, FEEDBACK_SEARCH } from 'src/constants/theme-setup';

type Props = {
  removeAll: boolean,
  value: number,
  handleChangeValueOption: (checked: boolean, newValue: number) => void
};

type ComposedProps = Props & WithI18nProps;

class Options extends Component<ComposedProps> {
  render() {
    const { i18n, handleChangeValueOption, value, removeAll } = this.props;
    const optionList = removeAll ? FEEDBACK_ALL : FEEDBACK_SEARCH;

    return (
      <div>
        <Stack vertical>
          {_.map(optionList, (option, index) => (
            <RadioButton
              label={i18n.translate(`AdminHTML.ThemeSetup.FeedbackModal.${option.label}`)}
              checked={value === option.id}
              id={option.id.toString()}
              name="options"
              onChange={handleChangeValueOption}
              key={index}
            />
          ))}
        </Stack>
      </div>
    );
  }
}

export default withI18n()(Options);
